import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/serviceBookingsSagas";
import { selectChartControlsDisabled } from "../redux/serviceBookingsSelectors";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const BreakdownChartFilter = ({ filterKey, placeholder }) => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.serviceBookings.filters[filterKey]);
  const breakdownFiltersLoader = useSelector(
    (state) => state.serviceBookings.breakdownFiltersLoader
  );
  const selectedOption = useSelector((state) => state.serviceBookings.selectedFilters[filterKey]);
  // Refetches without the Update button, so it must be inert whenever Update is.
  const disabled = useSelector(selectChartControlsDisabled);

  const onSelectChange = (data) => {
    if (data.id === selectedOption.id) return;
    dispatch(
      actionCreators.updateBreakdownChartFilter({ data: { [filterKey]: data }, filter: filterKey })
    );
  };

  return (
    <div
      className="select-box"
      style={{ width: "200px", ...(disabled && { cursor: "not-allowed" }) }}
    >
      <div {...(disabled ? { inert: "" } : {})}>
        {breakdownFiltersLoader === filterKey ? (
          <button className="picky__input">
            <LoadingAnimation uiLoader />
          </button>
        ) : (
          <MultiSelectDropdown
            options={options}
            selectedFilters={selectedOption}
            placeholder={placeholder}
            onSelectChange={onSelectChange}
          />
        )}
      </div>
    </div>
  );
};

export default BreakdownChartFilter;
